import React from 'react';

import { new_session_path } from '../../routes';
import { TIModal } from '../BaseUI';
import Benefits from './Benefits';

const ProfileModal = ({ modalContent, enableProfile, currentUserLoggedIn, newSessionUrl }) => {
  return (
    <TIModal
      isOpen={true}
      parentClass="subscribe-modal"
      disableScrollLock={false}
      modalContent={
        <div className="modal-container">
          <div className="header">{modalContent.header}</div>
          <div className="subheader">{modalContent.subheader}</div>
          <div className="action-container">
            {modalContent.updateLink ? (
              <button
                onClick={() =>
                  enableProfile({
                    profile_enabled: true,
                    message_enabled: true,
                  })
                }
              >
                {modalContent.linkName}
              </button>
            ) : (
              <a href={modalContent.link()}>{modalContent.linkName}</a>
            )}
          </div>
          {!currentUserLoggedIn && (
            <div className="log-in-link">
              Already have an account?{' '}
              <a href={newSessionUrl ? newSessionUrl : new_session_path()}>Log in here</a>
            </div>
          )}
          <Benefits benefits={modalContent.benefits} topMargin="Large" />
        </div>
      }
    />
  );
};

export default ProfileModal;
